import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { LIVE_SITE_URL, NO_INDEX } from '../../constants/userConstant';

/**
 * SEO Component to set canonical URLs for all live pages
 * Ensures only https://memorised.com.au is used as canonical
 * Prevents staging from being selected as canonical
 * Resolves Google Search Console issues:
 * 1. Duplicate without user-selected canonical
 * 2. Page with redirect
 */

const SEO = ({ canonical = null }) => {
  const location = useLocation();

  // Always use the live domain, strip query/hash, remove trailing slash except root
  const getCanonicalUrl = () => {
    if (canonical) return canonical;

    let path = location.pathname.replace(/\/+$/, '') || '/';
    return `${LIVE_SITE_URL}${path}`;
  };
  const canonicalUrl = getCanonicalUrl();

  useEffect(() => {
    let linkCanonical = document.querySelector('link[rel="canonical"]');
    if (!linkCanonical) {
      linkCanonical = document.createElement('link');
      linkCanonical.setAttribute('rel', 'canonical');
      document.head.appendChild(linkCanonical);
    }
    linkCanonical.setAttribute('href', canonicalUrl);

    // Conditionally add or remove noindex meta tag based on NO_INDEX flag
    let metaNoIndex = document.querySelector('meta[name="robots"]');
    if (NO_INDEX) {
      if (!metaNoIndex) {
        metaNoIndex = document.createElement('meta');
        metaNoIndex.setAttribute('name', 'robots');
        document.head.appendChild(metaNoIndex);
      }
      metaNoIndex.setAttribute('content', 'noindex, nofollow');
    } else {
      // Remove noindex if present
      if (metaNoIndex) {
        metaNoIndex.parentNode.removeChild(metaNoIndex);
      }
    }
  }, [canonicalUrl]);

  return null;
};

export default SEO;